import React from 'react';
import { FormView } from '@bp/components';
import { useCreateNode } from './useCreateNode';

export const CreateNode = () => {
  const props = useCreateNode();

  return <FormView {...props} />;
};
